import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class TrialSignupValidationService {
    phoneStripRegex = /[^\d+x]+/;

    passwordComplexityRegex = /(?=.*[a-z])(?=.*[A-Z])/;

    constructor(private ajax: AjaxService, private urls: UrlsService) {}

    public validatePhone(phoneNumber: string): string | null {
        if (!phoneNumber) {
            return null;
        }
        const nonCharPhone = phoneNumber.replace(this.phoneStripRegex, '');
        let phoneError = null;

        if (!nonCharPhone || nonCharPhone.length < 4 || nonCharPhone.length > 11 + 5 + 4) {
            // Length of phone numbers comes from here:
            // http://msdn.microsoft.com/en-us/goglobal/bb688129.aspx
            // 11 + 5 + 4 is 'max phone number length' + 'max extension length' +
            // 'max country code length'
            phoneError = 'Please enter a valid phone number.';
        }
        return phoneError;
    }

    validateEmail(emailVal: string): Observable<string | null> {
        return this.ajax
            .postFormEncodedDataObserveResponse<string>(this.urls.STORE.VALIDATE_FREE_TRIAL_EMAIL, { email: emailVal })
            .pipe(
                map((response: HttpResponse<string>) => (response.ok ? null : response.body)),
                catchError((err: HttpErrorResponse) => of(err.error))
            );
    }

    validatePassword(passwordVal: string): string | null {
        if (!passwordVal) {
            return null;
        }
        const isValid = this.passwordComplexityRegex.test(passwordVal);
        let passwordError = null;

        if (!isValid) {
            passwordError =
                'Password must contain at least 1 lowercase letter, 1 upper case letter, and 1 special character ' +
                '(!,@,#,$,%%,&).';
        }
        return passwordError;
    }
}
